import config from '../../../config';
import Cookie from '../../../ports-frontend/Cookie';

import { QUICKSILVER_FEATURES_COOKIE } from '../constants';
import { fromEntries } from 'src/utils/lodash-alternatives';
import { FeatureModeType, FeatureStateType, FeatureConfig } from '../types';

export const fetchFeatureFlagsConfig = async () => {
  const cookie = (await Cookie.get(QUICKSILVER_FEATURES_COOKIE)) || '';
  const flags = cookie.split(',').map(c => c.trim());

  const computeFeatureState = (
    name: string,
    mode: FeatureModeType
  ): FeatureStateType => {
    switch (mode) {
      case 'enabled':
        return 'active';
      case 'hidden':
        return flags.includes(name) ? 'active' : 'inactive';
      case 'disabled':
      default:
        return 'inactive';
    }
  };
  if (!Object.fromEntries) Object.fromEntries = fromEntries;
  return Object.fromEntries(
    Object.entries(config.features).map(([name, feature]): [
      string,
      FeatureConfig
    ] => {
      return [
        name,
        {
          mode: feature.mode,
          state: computeFeatureState(name, feature.mode),
        },
      ];
    })
  );
};
